<!-- TEMPLATE CONTRACT: Ui Badge Component owns the visible Angular template structure for src/app/shared/ui/ui-badge/ui-badge.component.html. -->
<span class="ui-badge" [attr.data-tone]="tone()">{{ label() | uiLabelTranslate }}</span>
